import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { PuSubscribable } from '@app/utils/pu-subscribe';

export enum CostFileTicketPartsMenuEnum {
  Off = 0,
  On = 1,
  Setup = 2,
}

@Component({
  selector: 'app-cost-file-ticket-parts-menu',
  templateUrl: './cost-file-ticket-parts-menu.component.html',
  styleUrls: ['./cost-file-ticket-parts-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostFileTicketPartsMenuComponent extends PuSubscribable {
  @Input() selectedOption: CostFileTicketPartsMenuEnum = CostFileTicketPartsMenuEnum.Off;
  @Output() submitForm = new EventEmitter<CostFileTicketPartsMenuEnum>();

  readonly CostFileTicketPartsMenuEnum = CostFileTicketPartsMenuEnum;

  setOn(): void {
    this.submitForm.emit(CostFileTicketPartsMenuEnum.On);
  }

  setOff(): void {
    this.submitForm.emit(CostFileTicketPartsMenuEnum.Off);
  }

  setup(): void {
    this.submitForm.emit(CostFileTicketPartsMenuEnum.Setup);
  }
}
